export const UPDATE_NAVS= 'UPDATE_NAVS';